<template lang="pug">
.online-meeting-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :filter="filter"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
    :filter-function="filterTable"
    @filtered="onFiltered"
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません
    // フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません

    // セル：日時
    template(#cell(startAndEnd)="row")
      span {{ convertStartAndEnd(row.item) }}
    // セル：主催者
    template(#cell(isMain)="row")
      span(v-if="row.item.isMain == true") ○
    // セル：操作
    template(#cell(futureOperation)="row")
      button.btn.detail-btn.mr-2(@click="onDetail(row.item)" type="button") 詳細
      button.btn.edit-btn.mr-2(@click="onEdit(row.item)" type="button" :class="{ 'disable': !row.item.isMain }" :disabled="!row.item.isMain") 修正
      button.btn.delete-btn.mr-2(@click="onDelete(row.item)" type="button" :class="{ 'disable': !row.item.isMain }" :disabled="!row.item.isMain") 削除
      button.btn.meeting-btn(@click="onMeeting(row.item)" type="button") 会議開始
    // セル：操作
    template(#cell(historyOperation)="row")
      button.btn.detail-btn(@click="onDetail(row.item)" type="button") 詳細
</template>

<script lang="ts">
import { OtherOfficeOnlineMeetingGetModel } from "@/commons/services/OtherOfficeOnlineMeetings";
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### 他事業所連携 オンライン会議テーブルコンポーネント
 */
@Component({})
export default class OnlineMeetingTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<OnlineMeetingTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<OnlineMeetingTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;
  /** フィルター */
  @Prop()
  filter!: FilterSetting;

  get _value(): Array<OnlineMeetingTableItem> {
    return this.value;
  }

  public convertStartAndEnd(item: OnlineMeetingTableItem): string {
    const startDatetime = this.$dateUtil.convertNumberToString(item.startDatetime, "yyyy年mm月dd日 hh：MM");
    const endTime = this.$dateUtil.convertNumberToString(item.endDatetime, "hh：MM");
    return `${startDatetime}～${endTime}`;
  }

  /**
   * ### フィルタリング
   */
  public filterTable(row: OnlineMeetingTableItem, filter: FilterSetting): boolean {
    return this.filterFacilityId(row, filter) && this.filterSearchWords(row, filter);
  }

  public filterFacilityId(row: OnlineMeetingTableItem, filter: FilterSetting): boolean {
    if (filter.id == "") {
      return true;
    }

    if (row.targetFacilityId == Number(filter.id)) {
      return true;
    } else {
      return false;
    }
  }

  public filterSearchWords(row: OnlineMeetingTableItem, filter: FilterSetting): boolean {
    if (filter.searchWord == "") {
      return true;
    }

    const words: string[] = this.$filterUtil.createSearchWord(filter.searchWord);

    let foundTitle: boolean = true;
    for (const word of words) {
      if (row.title.indexOf(word) == -1) {
        foundTitle = false;
      }
    }

    return foundTitle;
  }

  /**
   * ### フィルタリングイベント
   */
  public onFiltered(filteredItems: any) {
    this.$emit("update:totalRows", filteredItems.length);
    return;
  }

  /**
   * ### 詳細ボタン押下イベント
   */
  public onDetail(item: OnlineMeetingTableItem): void {
    this.$emit("onDetail", item);
    return;
  }

  /**
   * ### 修正ボタン押下イベント
   */
  public onEdit(item: OnlineMeetingTableItem): void {
    this.$emit("onEdit", item);
    return;
  }

  /**
   * ### 削除ボタン押下イベント
   */
  public onDelete(item: OnlineMeetingTableItem): void {
    this.$emit("onDelete", item);
    return;
  }

  /**
   * ### 会議開始ボタン押下イベント
   */
  public onMeeting(item: OnlineMeetingTableItem): void {
    this.$emit("onMeeting", item);
    return;
  }
}

/** テーブルの列名の情報 */
export interface OnlineMeetingTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface OnlineMeetingTableItem extends OtherOfficeOnlineMeetingGetModel {}

export interface FilterSetting {
  id: string;
  searchWord: string;
}
</script>

<style lang="scss" scoped>
.resident-table-component {
  .family-detail-btn,
  .print-btn,
  .edit-btn,
  .delete-btn {
    width: 64px;
  }

  .edit-btn {
    margin-right: 8px;
  }

  .family-count {
    word-break: break-all;
    width: 55px;
    text-align: center;
  }
  .family-detail {
    width: 64px;
    text-align: center;
  }
}
</style>
